export class AccountUpdateInput {
    'id';
    'cloudProvider';
    'providerAccountId';
    'role';
    'regions';
    'tags';
    'name';
    'tenantId';
    'applicationId';
    'principalId';
    'overrideDefaultNetworkConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "applicationId",
            "baseName": "applicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "principalId",
            "baseName": "principalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "overrideDefaultNetworkConfig",
            "baseName": "overrideDefaultNetworkConfig",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountUpdateInput.attributeTypeMap;
    }
    constructor() {
    }
}
